//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DateAndTime',
  data() {
    return {
      isShowCalendar: false,
      isShowHours: false,
      dates: [],
      appointmentDay: null,
      appointmentDate: {},
      swiperOptionsSpecialistDate: {
        spaceBetween: 8,
        slidesPerView: 2.3,
        breakpoints: {
          990: {
            slidesPerView: 4,
          },
        },
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--date',
          prevEl: '.swiper-button-prev--date'
        }
      },
      swiperOptionsSpecialistTime: {
        spaceBetween: 8,
        slidesPerView: 2.3,
        breakpoints: {
          990: {
            slidesPerView: 5,
          },
        },
        loop: false,
        navigation: {
          prevEl: '.swiper-button-prev--time',
          nextEl: '.swiper-button-next--time'
        }
      },
    }
  },
  created() {
    this.setDates();
  },
  watch: {
    workTime() {
      this.setDates();
    }
  },
  methods: {
    setAppointmentHours(appointmentTime) {
      this.appointmentDate = {
        day: this.appointmentDay.date,
        start: appointmentTime.begin,
        end: appointmentTime.end,
        value: `${this.appointmentDay.value}-${appointmentTime.begin}-${appointmentTime.end}`
      }
      this.$emit('setApointmentTime', this.appointmentDate);
    },
    setDates() {
      let dates = [];
      let initialDates = this.workTime;

      Object.keys(initialDates).map((key, idx) => {
        let date = new Date(key);
        let times = initialDates[key]

        dates.push({
          value: `${key}-${idx}`,
          date: date,
          day: this.$moment(date).format("dd"),
          times: times

        });
      })
      this.dates = dates;
    },
  },
  emits: ['setApointmentTime'],
  props: {
    workTime: {
      type: Object,
      required: true,
    },
    isRequired: {
      type: Boolean,
      required: false
    }
  },
}
